import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';

type Props = {
  children: any;
  closeSheet: any;
};

function BottomSheet({ children, closeSheet }: Props) {
  return (
    <Container>
      <Content>
        <BtnClose />
        {children}
      </Content>
      <Overlay onClick={closeSheet}></Overlay>
    </Container>
  );
}

export default BottomSheet;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const BtnClose = styled('span')`
  position: absolute;
  top: 8px;
  height: 8px;
  border-radius: 8px;
  width: 80px;
  background: #ddd;
  left: 50%;
  transform: translateX(-50%);
`;

const Content = styled('div')`
  margin-top: auto;
  width: 100%;
  max-height: 100%;
  overflow-y: scroll;
  position: relative;
  z-index: 2;
  animation-name: ${slideUp};
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-timing-function: ease;
  padding-top: 24px;
  background: #fff;
  border-radius: 4px 4px 0 0;
`;

const Overlay = styled('div')`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  animation-name: ${fadeIn};
  animation-duration: 0.4s;
  animation-iteration-count: 1;
  animation-timing-function: ease;
`;

const Container = styled('div')`
  position: fixed;
  z-index: 104;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;
  padding-top: 64px;
`;
